import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BalanceSheetReportLine  {
    _originalTypeClassName = "zERP.BO.BalanceSheetReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BalanceSheetReportLine.translate = translateService;
}
this.AccountCode = null;
this.AccountDescription = null;
this.Amount = null;
this.AccountId = null;
this.BalanceSheetReportLineKey = null;
this._key = this.BalanceSheetReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
AccountCode:any;
AccountDescription:any;
Amount:any;
AccountId:any;
private _BalanceSheetReportLineKey:any;
get BalanceSheetReportLineKey(): any {
    return this._BalanceSheetReportLineKey;
  }
set BalanceSheetReportLineKey(value: any) {
    this._BalanceSheetReportLineKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BalanceSheetReportLineKey == null || $this.BalanceSheetReportLineKey == 0;
            }


}